import { CRUDEntity } from "../abstracts/CRUDEntity";
import { EntityModalForm } from "../abstracts/mixins/EntityModalForm";
import { FormActions } from "../abstracts/mixins/FormActions";
import { HasStatus } from "../abstracts/mixins/HasStatus";
import { RelatedEntities } from "../abstracts/mixins/RelatedEntities";
import { SaveButton } from "../../components/SaveButton";

import { HasAttachments } from "../abstracts/mixins/HasAttachments";
import { InputSelector } from "../../components/InputSelector";
import masks from "../../masks";

export class JobRequest extends CRUDEntity {

    constructor(id=null) {
        super();
        this.entityClass = 'request';
        this.urlRoot = '/jobs-flow/request';
        this.sectionRootUrl = '/jobs-flow';
        this.id = id;

        Object.assign(JobRequest.prototype, FormActions);
        Object.assign(JobRequest.prototype, EntityModalForm);
        Object.assign(JobRequest.prototype, HasStatus);
        Object.assign(JobRequest.prototype, RelatedEntities);
        Object.assign(JobRequest.prototype, HasAttachments);

        JobRequest.prototype.completeForm = function(formId, info=null, self=null) {
            const infoArr = Object.assign(FormActions.completeForm(formId, info, this), info);

            $('[data-job-id]').attr('data-job-id', this.id);
            if (infoArr.worker_comments) {
                JSON.parse(infoArr.worker_comments).forEach(element => {
                    $('#worker_comments_container').append(`<div class="mt-2">${element}</div>`)
                });
            }
        }

        JobRequest.prototype.delegatedListnersForButtons = function(type,entityClass){
            if ($(`#${type}-${entityClass}-modal #customer-select`).length) {

                masks.init()

                this.itemSelector = new InputSelector(`#${type}-${entityClass}-modal #customer-select`)

                $(this.itemSelector.element).on('select-item', (ev) => {
                    if (this.itemSelector.selectedValueField)
                        $(this.itemSelector.selectedValueField).attr('disabled', false)
                    $('.create-new-customer').addClass('d-none');
                })
                $(this.itemSelector.element).on('no-data', (ev) => {
                    if (ev.originalEvent.detail.value) {
                        $(this.itemSelector.noDataElement).find('.no-data-text').html(`<span>Create new customer <b>${ev.originalEvent.detail.value}</b></span>`)
                    }
                })
                $('.create-new-customer-button').on('click', (e) => {
                    if (this.itemSelector.selectedValueField)
                        $(this.itemSelector.selectedValueField).attr('disabled', true)
                    let inputValue = this.itemSelector.inputField.value.split(/\s+/)
                    if (inputValue.length) {
                        $(`#${type}-${entityClass}-modal input[name="first_name"]`).val(inputValue[0])
                        $(`#${type}-${entityClass}-modal input[name="last_name"]`).val(inputValue?.[1] ?? '')
                    }
                    this.itemSelector.inputField.value = ''
                    this.itemSelector.toggleList(false)
                    this.itemSelector.filterItems()
                    e.preventDefault();
                    $('.create-new-customer').toggleClass('d-none');
                });
            }


            $(`#${type}-${entityClass} button#${type}`).off();
            $(`#${type}-${entityClass} button#${type}`).on('click', () => {
                if (type == 'create') {
                    this.create();
                }
                if (type == 'edit') {
                    this.update();
                }
            });
        }
        JobRequest.prototype.create = function () {
            const formId = `create-${this.entityClass}`
            const form = $(`#${formId}`)
            const data = form.serialize();
            let formData = new FormData(form[0]);

            /* if (this.attachments) {
                for (const attachment of this.attachments.processedAttachments ?? []) {
                    const blob = new File([attachment.data], `file_${attachment.name}`);
                    formData.append('attachments[]', blob);
                }
                console.log(formData);
            } */

            this.nextJobRequestStep(formData, form)
        }
        this.setAttachmentCallbackPreview();
    }

    nextJobRequestStep(prevStepData, prevForm){
        let prevStep = prevForm.data('step');
        let nextStep = prevStep + 1;
        let nextForm = $('.request-form-step-' + nextStep);
        if (nextForm.length > 0) {
            $('.request-form-steps').addClass('d-none');
            nextForm.toggleClass('d-none');
            $('button', nextForm).off();
            $('button', nextForm).on('click', (e) => {

                let validateResult = true;

                if (!$('.create-new-customer').hasClass('d-none')) {
                    validateResult = this.validateCustomer();
                }
                if (validateResult) {
                    const SaveBtn = new SaveButton('.request-form-step-' + nextStep);
                    // let formData = nextForm.serialize() + '&' + prevStepData;
                    let formData = new FormData(nextForm[0]);
                    for (const [key, value] of prevStepData) {
                        if (key == 'attachments') {
                            formData.append('attachments[]', value);
                        }else {
                            formData.append(key, value);
                        }
                        console.log(key, value, formData);

                    }
                    if (formData.get('send_email') == 'on') {
                        formData.delete('send_email');
                        formData.append('send_email', ($('#send_email').is(':checked') ? 'true' : 'false'));
                    }
                    this.sendData(formData, SaveBtn);

                }
            })
        } else {
            const SaveBtn = new SaveButton('.request-form-step-' + prevStep);
            this.sendData(prevStepData, SaveBtn);
        }
    }

    sendData(data, SaveBtn){
        $.ajax({
            url: `${this.urlRoot}/create`,
            method: 'POST',
            data: data,
            // enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            beforeSend: () => {
                SaveBtn.startLoading();
            },
            success: (response) => {
                this.id = response.id;
                SaveBtn.stopLoading(true).then(() => {
                    SaveBtn.showSuccess().then(()=>{
                        setTimeout(() => {
                            $(`#create-${this.entityClass}-modal`).modal('hide')
                            location.reload()
                        }, 1000)
                    });
                })
            },
            error: (response) => {
                SaveBtn.stopLoading().then(() => {
                    SaveBtn.showError()
                })
            }
        })
    }

    validateCustomer() {
        let email = $(".create-new-customer [name='email']");
        let phone = $(".create-new-customer [name='phone']");
        let first_name = $(".create-new-customer [name='first_name']");
        let last_name = $(".create-new-customer [name='last_name']");
        let errors = 0;

        if (/^\S+@\S+\.\S+$/.test(email.val())) {
            email.attr('style', '');
        } else {
            email.attr('style', 'border-color: #dc3545 !important');
            errors++;
        }

        if (/^\d{3}-\d{3}-\d{4}$/.test(phone.val())) {
            phone.attr('style', '');
        } else {
            phone.attr('style', 'border-color: #dc3545 !important');
            errors++;
        }

        if (first_name.val().length > 0) {
            first_name.attr('style', '');
        } else {
            first_name.attr('style', 'border-color: #dc3545 !important');
            errors++;
        }

        if (last_name.val().length > 0) {
            last_name.attr('style', '');
        } else {
            last_name.attr('style', 'border-color: #dc3545 !important');
            errors++;
        }

        return (errors > 0) ? false : true;
    }

    static statusList = {
        'submit': 1,
        'cancel': 2
    }

    convertToJob = () => {
        $.ajax({
            url: `${this.urlRoot}/${this.id}/convert-to-job`,
            method: 'POST',
            success: window.location.reload(true) //updateTables - не работает
        });
    }
}
